import { cn } from "@/lib/utils/index";

function Skeleton({ className, ...props }) {
  return (
    <div
      data-slot="skeleton"
      className={cn("bg-muted animate-pulse rounded-radius", className)}
      {...props}
    />
  );
}

export { Skeleton };
